export enum FormFieldSpecialType {
    AUDIT,
    FOREIGN_KEY_ID
}
